export enum OFFER_LIST_COLUMNS_VALUES {
  COMPANY_NAME = "companyName",
  BUSINESS_SECTOR = "businessSector",
  TITLE = "title",
  HOURS = "hoursPerDay",
  SALARY = "salary",
  CAREERS = "careers",
  APPROVAL_STATUS = "approvalStatus",
  UPDATED_AT = "updatedAt",
  ACTIONS = "actions"
}

export const OFFER_LIST_COLUMNS = [
  OFFER_LIST_COLUMNS_VALUES.COMPANY_NAME,
  OFFER_LIST_COLUMNS_VALUES.BUSINESS_SECTOR,
  OFFER_LIST_COLUMNS_VALUES.TITLE,
  OFFER_LIST_COLUMNS_VALUES.HOURS,
  OFFER_LIST_COLUMNS_VALUES.SALARY,
  OFFER_LIST_COLUMNS_VALUES.CAREERS,
  OFFER_LIST_COLUMNS_VALUES.APPROVAL_STATUS,
  OFFER_LIST_COLUMNS_VALUES.UPDATED_AT,
  OFFER_LIST_COLUMNS_VALUES.ACTIONS
];
